import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppFloat = () => {
  const whatsappService = () => {
    if (window.fbq) {
      window.fbq('track', 'Contact');
    }
    const whatsappLink = "https://wa.link/rxjy36";
    window.open(whatsappLink, '_blank');
  };

  return (
    <div className="vah-whatsapp-container">
      <div className="vah-whatsapp-float" onClick={whatsappService}>
        <div className="vah-whatsapp-icon">
          <MessageCircle size={24} />
        </div>
      </div>
      <div className="vah-support-text">
        Contact Support
      </div>
      <style jsx>{`
        .vah-whatsapp-container {
          position: fixed;
          bottom: 120px;
          right: 10px;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
        }
        .vah-whatsapp-float {
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }
        .vah-whatsapp-float:hover {
          transform: scale(1.1);
        }
        .vah-whatsapp-float:hover .vah-whatsapp-icon {
          background: #128C7E;
        }
        .vah-whatsapp-float:hover::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 68px;
          height: 68px;
          background: rgba(37, 211, 102, 0.1);
          border-radius: 50%;
          animation: ripple 1.5s infinite;
        }
        .vah-whatsapp-icon {
          background: #25D366;
          color: white;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
          animation: pulse 2s infinite;
          transition: background-color 0.3s ease;
        }
        .vah-support-text {
          color: #333;
          font-size: 14px;
          font-weight: 600;
          background: white;
          padding: 8px 16px;
          border-radius: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          text-align: center;
          white-space: nowrap;
        }
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }
        @keyframes ripple {
          0% {
            width: 60px;
            height: 60px;
            opacity: 1;
          }
          100% {
            width: 80px;
            height: 80px;
            opacity: 0;
          }
        }
        @media (max-width: 768px) {
          .vah-whatsapp-container {
            bottom: 80px;
            right: 8px;
          }
          .vah-whatsapp-icon {
            width: 50px;
            height: 50px;
          }
          .vah-support-text {
            font-size: 12px;
            padding: 6px 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppFloat;
